let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("MJwFb"), load("dhqJV")]).then(() => parcelRequire('fzbVm'));